module.exports = __webpack_public_path__ + "static/media/munich_demonstr.c6af3d1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/normals/munich_demonstr.jpg
// module id = 425
// module chunks = 0